export const CARD_NUMBER_MASK = [
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  ' ',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  ' ',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  ' ',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
];

export const EXPIRY_DATE_MASK = [/\d/, /\d/, '/', /\d/, /\d/];

export const CVV_NUMBER_MASk = [/\d/, /\d/, /\d/, /\d?/];
